var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-multi" }),
        _vm._v(_vm._s(_vm.$t("Label Firmware")) + " ")
      ]),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01 mt-10 products",
          attrs: {
            "item-key": "id",
            headers: _vm.labelFirmwareListHeaders,
            items: _vm.labelFirmwareList,
            "hide-default-footer": true,
            "items-per-page": _vm.labelFirmwareList.length,
            "fixed-header": "",
            height: "528"
          }
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")])
          ])
        ],
        2
      ),
      _c("label-firmware-uploader", {
        attrs: { btnDisabledFileUpload: _vm.btnDisabledFileUpload },
        on: { initLabelFirmware: _vm.initLabelFirmware }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }